<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner" *ngIf="!isRd && !isInterview">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">Blog</h1>
  </div>
</div>

<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner-interviews" *ngIf="!isRd && isInterview">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">Interviews</h1>
  </div>
</div>

<div class="container mt-5" id="news">

    <div class="mx-3 mb-4" *ngIf="!isRd && posts[0]">
      <h2 *ngIf="!isInterview" class="subhead mb-4">{{'Actualité à la une' | translate}}</h2>
      <h2 *ngIf="isInterview" class="subhead mb-4">{{'Interview à la une' | translate}}</h2>
      <app-actualite-card [postInfos]="posts[0]" [isRd]="isRd" [isInterview]="isInterview" [featuredPost]="featuredPost"></app-actualite-card>
    </div>

    <h2 *ngIf="!isInterview" class="subhead mb-4 mx-3">{{'Toutes les actualités' | translate}}</h2>
    <h2 *ngIf="isInterview" class="subhead mb-4 mx-3">{{'Toutes les interviews' | translate}}</h2>
    <ul class="filtres d-flex flex-wrap justify-content-start mb-4 mx-3" *ngIf="!isRd && !isInterview">
        <li (click)="selectTag(null)" class="rounded" [ngClass]="{'active': !activeTag}">{{'Tout' | translate}}</li>
        <li *ngFor="let tag of tags" class="rounded" (click)="selectTag(tag['id'])" [ngClass]="{'active': activeTag == tag.id}">{{tag.title}}</li>
    </ul>
    <div class="categories autres mb-5 pb-3">
        <div class="d-flex flex-column flex-md-row flex-wrap">
            <div class="col-md-6 col-lg-4 mb-5" *ngFor="let actu of posts">
                <app-actualite-card [postInfos]="actu" [isRd]="isRd" [isInterview]="isInterview"></app-actualite-card>
            </div>
        </div>
        <nav class="text-center" *ngIf="posts.length<nbPosts">
            <button class="btn btn-showmore" (click)="showMoreActu()">{{'Afficher plus' | translate}} <i class="ml-2 fas fa-arrow-down"></i></button>
        </nav>
    </div>
</div>
